import { jsx as _jsx } from "react/jsx-runtime";
export function getClassNameForSubstitutionType(type) { return "pdf-substitute-" + type; }
export function PDFSubstitution(props) { return /*#__PURE__*/ _jsx("span", { className: getClassNameForSubstitutionType(props.type), children: "\xA0" }); }
